export type Consent = {
  root?: boolean
  id: string
  title: string
  uri: string
  effectiveDate?: string
  appKey: string
  description?: string
  publish?: number
  version?: string
}

export interface LocationState {
  consent: Consent
}

export type Accordion = {
  title: string
  description: string
}

export type Action = {
  effectiveDate?: string
  uri?: string
}

export enum PRIVACY_TYPE {
  PRIVACY_NOTICE = 'privacy-notice',
  SERVICE_LIST = 'service-list',
  SERVICE = 'service'
}
export enum VIEW_TYPE {
  LIST,
  DETAIL
}

export const handleDownload = (title, content, accordions?) => {
  if (content === undefined) return
  let encodedHtmlContent = `<html><head><meta http-equiv="Content-Type" content="text/html; charset=utf-8"></head><div>`
  encodedHtmlContent += `<h1>${title}</h1>`
  encodedHtmlContent += `<p>${content}</p><br>`
  accordions &&
    accordions.forEach((accordion) => {
      encodedHtmlContent += `<h3>${accordion.title}</h3>`
      encodedHtmlContent += `<p>${accordion.description}</p><br>`
    })
  encodedHtmlContent += `</div></html>`

  const blob: Blob = new Blob([encodedHtmlContent], { type: 'text/html; charset=utf-8' })
  const url = window.URL.createObjectURL(blob)
  const aTag = document.createElement('a')
  aTag.href = url
  aTag.download = `${title}.html`
  aTag.click()
  aTag.remove()
  window.URL.revokeObjectURL(url)
}

export const trim = (t) => {
  t = t.trim()
  while (t.startsWith('<br>')) {
    t = t.substring(4).trimStart()
  }
  while (t.endsWith('<br>')) {
    const l = t.length
    t = t.substring(0, l - 4).trimEnd()
  }
  return t
}

export const getListLength = (document) => {
  return document.querySelectorAll('[id^="listTitle"]').length
}

export const appendLegacyParams = (href: string, language: string, paramCountryCode?: string): string => {
  try {
    const url = new URL(href)
    url.searchParams.set('paramLocale', language)
    if (paramCountryCode) {
      url.searchParams.set('countryCode', paramCountryCode)
    }
    return url.toString()
  } catch {
    return href
  }
}

export const buildPolicySearch = (
  searchParams: URLSearchParams,
  extraParams: Record<string, string | undefined> = {}
): string => {
  const nextParams = new URLSearchParams()
  const policySearchParamKeys = ['countryCode', 'locale']

  policySearchParamKeys.forEach((key) => {
    const value = searchParams.get(key)
    if (value) {
      nextParams.set(key, value)
    }
  })

  Object.entries(extraParams).forEach(([key, value]) => {
    if (value) {
      nextParams.set(key, value)
    } else {
      nextParams.delete(key)
    }
  })

  const queryString = nextParams.toString()
  return queryString ? `?${queryString}` : ''
}
